/**
 * Match the height of all .product-card p[role="heading"] elements
 * within each visual row so titles align evenly across a grid.
 */
(function () {
  // const SELECTOR = '.product-card p[role="heading"]';
  const SELECTOR = '.product-card [ref="productTitleLink"]';

  function matchHeadings() {
    const headings = Array.from(document.querySelectorAll(SELECTOR));
    if (!headings.length) return;

    // Reset heights so we can measure natural sizes
    headings.forEach((el) => (el.style.height = ''));

    // Group headings that share the same top offset (i.e. same row)
    const rows = new Map();
    headings.forEach((el) => {
      const top = el.getBoundingClientRect().top + window.scrollY;
      const key = Math.round(top); // round to avoid sub-pixel differences
      if (!rows.has(key)) rows.set(key, []);
      rows.get(key).push(el);
    });

    // Set each row to the tallest heading's height
    rows.forEach((row) => {
      const max = Math.max(...row.map((el) => el.offsetHeight));
      row.forEach((el) => (el.style.height = max + 'px'));
    });
  }

  // Run after paint
  function run() {
    requestAnimationFrame(matchHeadings);
  }

  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('resize', run);

  // Re-run when Shopify section content is updated (theme editor / filters / pagination)
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('page:load', run); // View Transitions API hook used by this theme
})();
